import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExcluirAlteracao = ({ sqAltExec }) => {
  const {
    request: excluirRequest,
    data: excluirData,
    errors: excluirErrors,
    isLoading: excluirIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (excluirIsLoading) return;

    if (!excluirData && !excluirErrors) return;

    if (excluirData) {
      toast.success("Alteração excluída com sucesso!");
      window.location.reload();
    }
  }, [excluirData, excluirErrors, excluirIsLoading]);

  const excluirAlteracao = () => {
    excluirRequest(apiRoutes.fiscalizacao.alteracaoexecutor.excluirAlteracao, {SequencialAlteracaoExecutor: sqAltExec,});
  };

  return { excluirAlteracao, excluirErrors, excluirIsLoading, excluirData };
};

export default useExcluirAlteracao;
